import { unescapeAndDecode } from '@aboutyou/legacy-shared/src/utils/url-utils'
import { useSearchPageStore } from 'store/context'

export const useSearchTerm = () => {
  const searchPageStore = useSearchPageStore()

  const termParam = searchPageStore.filter.selectedFilters.term

  return termParam ? unescapeAndDecode(termParam[0]) : ''
}
